module.exports = __webpack_public_path__ + "static/media/slide4.372b56a9.png";